import { getInstance } from './authWrapper';

export default function authGuard(to, from, next) {
  const authService = getInstance();

  const fn = () => {
    if (authService.is_authenticated) {
      return next();
    }

    (async () => {
      const token = await authService.getToken();
      if (token) {
        // successful (silent) authentication: redirect to next route
        // -> failed (silent) authentication: getToken() will have already redirected to universal login
        authService.is_authenticated = true;
        return next();
      }
      return false;
    })();
    return false;
  };

  if (!authService.loading) return fn();
  authService.$watch('loading', (loading) => (loading === false ? fn() : false));
  return null;
}
